import 'apps/pathways/styles/app/start/steps/four.scss';
import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import PropTypes from 'prop-types';
import Loading from 'components/loading';
import Query from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';
import Cache from 'library/util/cache';
import query_string from 'library/util/query-string';
import Results from 'apps/pathways/components/start-results';
import Search from 'apps/pathways/components/search';
import Preferences from 'apps/pathways/components/preferences';

export default class StepFour extends React.Component {
  static propTypes = {
    graph_loading: PropTypes.bool,
    graph_data: PropTypes.any,
    location: PropTypes.object
  }

  constructor(...params) {
    super(...params);

    this.state = {
      loading: true,
      preferences: {}
    };
  }

  componentDidMount() {
    this.loadInitial();
  }

  loadInitial = async () => {
    this.setState({
      loading: false,
      preferences: {
        ...((await Cache.get('preferences_filters', 'interface_preferences')) || {}),
        ...resolve((await Cache.get('opportunity_preferences', 'graph_data')), 'account/opportunity_preferences', {})
      }
    });
  }

  renderLoading = () => (
    <div className="signup-step-four-loading">
      <Loading />
    </div>
  )

  update = async () => {
    this.setState({
      preferences: {
        ...((await Cache.get('preferences_filters', 'interface_preferences')) || {}),
        ...resolve((await Cache.get('opportunity_preferences', 'graph_data')), 'account/opportunity_preferences', {})
      }
    });
    return await this.props.reload_graph(true);
  }

  render() {
    const {
      graph_loading,
      graph_data,
      location
    } = this.props;

    if (graph_loading || this.state.loading) {
      return this.renderLoading();
    }

    const query = query_string(location.search).q;

    return (
      <div className="signup-step-four">
        <Search preferences={this.state.preferences} query={query}>
          <Preferences onUpdate={this.update} />
        </Search>
        {
          !query
            ? <Results loading={graph_loading} preferences={this.state.preferences} {...graph_data} />
            : null
        }
      </div>
    );
  }
}

StepFour.requiresAuthentication = true;
StepFour.parseQueryData = (d) => {
  d.hawt = resolve(d, 'hawt/results', []);
  d.matches = resolve(d, 'matches/results', []);
  d.pagination = {
    hawt: resolve(d, 'hawt/pagination', {total: 0}),
    matches: resolve(d, 'matches/pagination', {total: 0})
  };
  return d;
};
StepFour.query = async (cancelToken) => {
  const preferences = (await Cache.get('preferences_filters', 'interface_preferences')) || {};

  const fields = `
    results {
      id
      title
      match
      hawt
      opportunity
      location {
        title
      }
      education {
        minimum_requirement
      }
      employment {
        jobs_per_1000
        projected_employment
        total_employed
      }
      description
      industries {
        title
      }
      wage {
        mean_annual_rate
        mean_hourly_rate
        median_annual_rate
        median_hourly_rate
      }
    }
  `;

  return await Query(`
    {
      matches: occupations(${jsonToInputParams({order: 'desc', order_by: 'match', limit:3, ...preferences})}) {
        ${fields}
        pagination {
          total
        }
      },
      hawt: occupations(${jsonToInputParams({hawt: true,order: 'desc', order_by: 'match', limit:1, ...preferences})}) {
    		${fields}
        pagination {
          total
        }
      }
    }
  `, null, {redirectOnUnauthorized:false,cancelToken: cancelToken });
};
